module.exports = __webpack_public_path__ + "img/49.72a0df6e.svg";